<template>
  <div class="service-wrap">
    <el-form :inline="false" :model="formData">
       
      <el-form-item label="自动调用参数">
        <el-radio-group v-model="formData.auto" label="开关">
         <el-radio  key="0" label="1">是</el-radio>
         <el-radio  key="1" label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="自动调用次数">
        <el-input  label="自动调用次数" v-model="formData.autoTime"  placeholder="自动调用次数，10次就输入：10"></el-input>
      </el-form-item>
      <el-form-item label="自动变量递增数值">
        <el-input  label="自动变量递增数值" v-model="formData.autoCodeAdd"  placeholder="自动变量递增数值，参考：start=20;end=20;即start每次递增20，end每次递增20"></el-input>
      </el-form-item>
      <el-form-item label="并发请求">
        <el-input v-model="formData.thread" placeholder="每次自动调用并发请求次数"></el-input>
      </el-form-item>
      <el-form-item label="service接口号">
        <el-input v-model="formData.service" placeholder="接口号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="onClear">清空</el-button>
        <el-button type="primary" @click="specialParam">特殊参数</el-button>
      </el-form-item>
      <el-form-item label="特殊参数" v-show="type == '0'">
        <el-input type="textarea" :rows="3" placeholder="service输入参数，格式参考：JSON格式" v-model="formData.param"></el-input>
      </el-form-item>
      <el-form-item label="接口入参" v-show="type == '1'">
        <el-input type="textarea" :rows="3" placeholder="service输入参数，格式参考：start=0;end=20;"
          v-model="formData.param"></el-input>
      </el-form-item>
      <el-form-item label="头部信息">
        <el-input type="textarea" :rows="6" placeholder="ANS_MSG_HDR，service返回的头信息" v-model="formData.ANS_MSG_HDR">
        </el-input>
      </el-form-item>
      <el-form-item label="返回数据">
        <el-input type="textarea" :rows="12" placeholder="ANS_COMM_DATA，service返回的数据" v-model="formData.ANS_COMM_DATA">
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import oppService from "@/service/opp-service";
import { promise } from "ora";

export default {
  data () {
    return {
      showloading: false,
      type: "1",
      formData: {
        auto:"0",
        autoTime:10,
        autoCodeAdd:"start=10;end=10",
        thread:6,
        param: "start=0;end=10;force=true;ignoreImgErr=true;allTimeout=9999;",
        ANS_MSG_HDR: "",
        ANS_COMM_DATA: ""
      }
    };
  },
  components: {},
  async mounted () { 
    let flag = await oppService.getSysCommonParamsFromCacheObjs("FXC_HTTP_TEST");
    if(flag != "1"){
      alert("无权访问");
      this.$router.replace("/userLogin");
    }
  },
  watch: {
    showloading (v) {
      if (v) {
        this.myLoading({
          loadingText: "正在加载数据&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    }
  },
  methods: {
    openMsgBox (msg, callback) {
      this.alert({
        messageText: msg,
        confirmedAction: callback || new Function()
      });
    },
    async onSubmit () {
      let that = this,paramObj={};
      let startT = new Date().getTime();
      if (!that.formData.service) {
        that.openMsgBox("service号必传！");
        return;
      }
      if(that.formData.auto == "1"){
        try {
          that.formData.param && that.type == "1" &&
        _.each(that.formData.param.split(";"), function (value) {
          let paramArr = value.split("=");
          paramObj[paramArr[0]] = paramArr[1];
        });
          //解析自动调用接口入参
          let autoCodeArr = that.formData.autoCodeAdd.split(";");
          let autoCodeObj = {};
          _.each(autoCodeArr, function (value) {
            let paramArr = value.split("=");
            //{start: 20, end:20}
            autoCodeObj[paramArr[0]] = paramArr[1];
          });       
          let getRequeset = function (i){
            let cloneObj = _.cloneDeep(paramObj);
            for(let key in autoCodeObj){
              cloneObj[key] =  parseInt(cloneObj[key]) + parseInt(autoCodeObj[key])*i;
            }
            if (that.formData.param && that.type == "0") {
              cloneObj = JSON.parse(that.formData.param);
            }
            console.info(`调用次数${i}入参${JSON.stringify(cloneObj)}`);
            return that.post(cloneObj);
          }; 
          let arr = [];
          for(let i = 0; i < that.formData.autoTime; i++){
            arr.push(getRequeset(i));
            if(arr.length >=  that.formData.thread || i == that.formData.autoTime-1){
              consoleLog("开始并发请求，i===",i);
              await Promise.all(arr);
              consoleLog("结束并发请求，i===",i);
              arr = [];
            }
          }
        
        } catch (e) {
          consoleError("接口参数格式失败",e);
          that.openMsgBox("输入的参数不合法!");
        }
      }else{
        try {
          that.formData.param && that.type == "1" &&
        _.each(that.formData.param.split(";"), function (value) {
          let paramArr = value.split("=");
          paramObj[paramArr[0]] = paramArr[1];
        });
          if (that.formData.param && that.type == "0") {
            paramObj = JSON.parse(that.formData.param);
          }
        } catch (e) {
          that.openMsgBox("输入的参数不合法!");
          return;
        }
        await this.post(paramObj);
      }
      let endTime = new Date().getTime();
      consoleLog("总耗时"+"接口耗时:" + (endTime - startT) / 1000 + "秒");
    },
    post (paramObj){
      let that = this;
      let startDate = new Date().getTime();
      this.formData.ANS_COMM_DATA = "";
      this.formData.ANS_MSG_HDR = "";
      that.showloading = true;
      return this.$syscfg
        .K_Request(that.formData.service, paramObj)
        .then(function (data) {
          let endDate = new Date().getTime();
          that.formData.ANS_COMM_DATA =
            data && data.Data && JSON.stringify(data.Data);
          that.formData.ANS_MSG_HDR =
            data &&
            JSON.stringify({
              Code: data.Code,
              Msg: data.Msg,
              RunTimes: "接口耗时:" + (endDate - startDate) / 1000 + "秒"
            });
          if(that.formData.service=="F0000101"){
            consoleLog("返回结果，迁移从"+data.Data[0].start+"到"+data.Data[0].end);
            if(_.get(data, "Data[0].flowErrorList.length")){
              consoleLog("返回错误流程转换结果", _.get(data, "Data[0].flowErrorList"));
            }
            if(_.get(data, "Data[0].imgErrorList.length")){
              consoleLog("返回影像错误结果", _.get(data, "Data[0].imgErrorList"));
            }
            if(_.get(data, "Data[0].oldToNewErrorList.length")){
              consoleLog("返回数据转换错误结果", _.get(data, "Data[0].oldToNewErrorList"));
            }
            if(_.get(data, "Data[0].yztTofxcErrorList.length")){
              consoleLog("返回一站通同步非现场错误结果", _.get(data, "Data[0].yztTofxcErrorList"));
            }
            if(_.get(data, "Data[0].flowWarnList.length")){
              consoleLog("返回流程转换警告结果", _.get(data, "Data[0].flowWarnList"));
            }

            consoleLog("返回结果", data.Data);
          }
        })
        .catch(function (error) {
          that.openMsgBox("接口调用出错，请检查程序！");
        })
        .finally(function () {
          that.showloading = false;
        });
    },
    onClear () {
      this.formData.param = "";
      this.type = "1";
      this.formData.ANS_COMM_DATA = "";
      this.formData.ANS_MSG_HDR = "";
    },
    specialParam () {
      this.type = "0";
    }
  }
};
</script>
<style lang="less" >
.service-wrap {
  width: 94%;
  height: 94% !important;
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  .el-form-item{
    margin-bottom: 5px;
    .el-form-item__label{
      height: 18px;
      line-height: 18px;
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/pages/serviceTest/test.vue